import { SpinnerIcon } from '../icons/SpinnerIcon';

interface Props {
    loading: boolean;
}

export const LoadingIndicator = ({ loading }: Props) =>
    loading ? (
        <div className="custom-ctrl-top loading-indicator u-border-radius-8px u-pa4 u-t4">
            Laster nye tilbud
            <SpinnerIcon className="spinner" />
        </div>
    ) : null;
